import { createContext, useContext, ReactNode } from "react";

type LoginModalContextType = {
  handleLoginWithCancel: () => void;
};

const LoginModalContext = createContext<LoginModalContextType | undefined>(
  undefined,
);

export const useLoginModalContext = () => {
  const context = useContext(LoginModalContext);
  if (!context) {
    throw new Error(
      "useLoginModalContext must be used within a LoginModalProvider",
    );
  }
  return context;
};

type LoginModalProviderProps = {
  children: ReactNode;
  onLoginWithCancel: () => void;
};

export const LoginModalProvider = ({
  children,
  onLoginWithCancel,
}: LoginModalProviderProps) => {
  return (
    <LoginModalContext.Provider
      value={{ handleLoginWithCancel: onLoginWithCancel }}
    >
      {children}
    </LoginModalContext.Provider>
  );
};
